import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Skeleton } from "primereact/skeleton";
import { Nav } from "react-bootstrap";

export const SliderSkeleton = () => {
  /**
   * Renders a skeleton component for a document.
   *
   * Returns a component that renders a document skeleton item, which includes
   * an image placeholder and two lines of text placeholders.
   *
   * @returns {JSX.Element} The rendered skeleton component.
   */

  return (
    <div key={"SkeletonDoc"} className="p-4">
      <Skeleton width="100%" height="650px"></Skeleton>
    </div>
  );
};
export const DocSkeleton = () => {
  /**
   * Renders a skeleton component for a document.
   *
   * Returns a component that renders a document skeleton item, which includes
   * an image placeholder and two lines of text placeholders.
   *
   * @returns {JSX.Element} The rendered skeleton component.
   */

  return (
    <div key={"SkeletonDoc"} className="p-4">
      <hr />
      <Row className="mb-3">
        <Col sm="2" className="d-flex align-items-center">
          <Skeleton width="100%" height="150px"></Skeleton>
        </Col>
        <Col sm="10">
          <Skeleton width="100%" height="4.2rem" className="mb-2"></Skeleton>
          <Skeleton width="100%" height="4.2rem" className="mb-2"></Skeleton>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="2" className="d-flex align-items-center">
          <Skeleton width="100%" height="150px"></Skeleton>
        </Col>
        <Col sm="10">
          <Skeleton width="100%" height="4.2rem" className="mb-2"></Skeleton>
          <Skeleton width="100%" height="4.2rem" className="mb-2"></Skeleton>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="2" className="d-flex align-items-center">
          <Skeleton width="100%" height="150px"></Skeleton>
        </Col>
        <Col sm="10">
          <Skeleton width="100%" height="4.2rem" className="mb-2"></Skeleton>
          <Skeleton width="100%" height="4.2rem" className="mb-2"></Skeleton>
        </Col>
      </Row>
    </div>
  );
};

export const QuickInfoSkeleton = () => {
  /**
   * QuickInfoSkeleton
   *
   * Renders a skeleton component for the quick information page.
   *
   * This component displays a skeleton for the quick information page, which includes
   * a left sidebar with a map, and a right content area with a top section
   * displaying the document image, followed by a section displaying the document
   * information, and a third section displaying the document facts.
   *
   * The skeleton includes several `Skeleton` components to display the loading
   * state of the page.
   *
   * @return {JSX.Element} The skeleton component for the quick information page.
   */

  return (
    <div key={"SkeletonDoc"} className="p-4">
      <Row className="main-content">
        <Col sm="6">
          <Skeleton width="100%" height="700px"></Skeleton>
        </Col>
        <Col sm="6" className="">
          <div className="pt-3 pb-2 ">
            <Skeleton width="100%" height="100%"></Skeleton>
          </div>

          <div>
            <div>
              <Skeleton
                width="100%"
                height="1.5rem"
                className="mb-2"
              ></Skeleton>
              <Skeleton
                width="100%"
                height="1.5rem"
                className="mb-2"
              ></Skeleton>
              <Skeleton
                width="100%"
                height="1.5rem"
                className="mb-2"
              ></Skeleton>
              <Skeleton
                width="100%"
                height="1.5rem"
                className="mb-2"
              ></Skeleton>
              <Skeleton
                width="100%"
                height="1.5rem"
                className="mb-2"
              ></Skeleton>
              <Skeleton
                width="100%"
                height="1.5rem"
                className="mb-2"
              ></Skeleton>
              <Skeleton
                width="100%"
                height="1.5rem"
                className="mb-2"
              ></Skeleton>
              <Skeleton
                width="100%"
                height="1.5rem"
                className="mb-2"
              ></Skeleton>
            </div>
            <hr className="my-4" />
            <div>
              <Skeleton width="100%" height="370px"></Skeleton>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export const TableSkeleton = () => {
  /**
   * TableSkeleton
   *
   * Renders a skeleton component for the table.
   *
   * This component displays a skeleton for the table, which includes
   * a list of skeleton items for the table.
   *
   * The skeleton includes several `Skeleton` components to display the loading
   * state of the table.
   *
   * @returns {JSX.Element} The skeleton component for the table.
   */

  return (
    <div key={"SkeletonDoc"} className="p-4">
      <div>
        <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
        <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
        <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
        <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
        <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
        <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
        <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
        <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
      </div>
    </div>
  );
};

export const LupdateSkeleton = () => {
  /**
   * LupdateSkeleton
   *
   * Renders a skeleton component for the l-update page.
   *
   * This component displays a skeleton for the l-update page, which includes
   * a list of skeleton items for the l-update.
   *
   * The skeleton includes several `Skeleton` components to display the loading
   * state of the page.
   *
   * @return {JSX.Element} The skeleton component for the l-update page.
   */

  const cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12];

  return (
    <div key={"SkeletonDoc"} className="row p-4">
      {cols.map((item, index) => {
        return (
          <div className="col-12 col-sm-3 my-5 " key={index}>
            <Skeleton width="100%" height="20rem" className="mb-2"></Skeleton>
          </div>
        );
      })}
    </div>
  );
};

export const NotificationSkeleton = () => {
  /**
   * Renders a skeleton component for notifications.
   *
   * This component displays a skeleton for the notifications page, which includes
   * a list of skeleton items for the notifications.
   *
   * The skeleton includes several `Skeleton` components to display the loading
   * state of the page.
   *
   * @return {JSX.Element} The skeleton component for the notifications page.
   */

  const cols = [1, 2, 3, 4];

  return (
    <div key={"SkeletonDoc"} className="row p-4">
      {cols.map((item, index) => {
        return (
          <div className="col-12 " key={index}>
            <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
          </div>
        );
      })}
    </div>
  );
};

export const UserSkeleton = () => {
  /**
   * A skeleton component for the user profile page.
   *
   * This component displays a skeleton for the user profile page, which includes
   * a top section displaying the user profile image, followed by a section
   * displaying the user profile information, and a third section displaying the
   * user's properties.
   *
   * The skeleton includes several `Skeleton` components to display the loading
   * state of the page.
   *
   * @return {JSX.Element} The skeleton component for the user profile page.
   */

  const cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div key={"UserSkeleton"} className="row p-4">
      {cols.map((item, index) => {
        return (
          <div className="col-12 " key={index}>
            <Skeleton width="100%" height="1.5rem" className="mb-2"></Skeleton>
          </div>
        );
      })}
    </div>
  );
};

export const DestinationSkeleton = () => {
  /**
   * A skeleton component for the destination page.
   *
   * This component displays a skeleton for the destination page, which includes
   * a left sidebar with a map, and a right content area with a top section
   * displaying the destination image, followed by a section displaying the
   * destination information, and a third section displaying the destination
   * facts.
   *
   * The skeleton includes several `Skeleton` components to display the loading
   * state of the page.
   *
   * @return {JSX.Element} The skeleton component for the destination page.
   */

  const cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div key={"destinationSkeleton"} className="p-4">
      <Row className="main-content">
        <Col sm="3">
          <Skeleton width="100%" height="700px"></Skeleton>
        </Col>
        <Col sm="9" className="">
          <div className="pt-3 pb-2 ">
            <Skeleton width="100%" height="100%"></Skeleton>
          </div>

          <div>
            <div>
              <Skeleton width="100%" height="10rem" className="mb-2"></Skeleton>
              <Skeleton width="100%" height="10rem" className="mb-2"></Skeleton>
            </div>

            <div className="row">
              <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                <div className="row g-0 about-destination ">
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <Skeleton shape="circle" size="5rem"></Skeleton>
                  </div>
                  <div className="col-12 col-sm-9 col-md-9 col-lg-9 dest-text align-middle">
                    <div className="mt-3">
                      <Skeleton className="mb-2"></Skeleton>
                      <Skeleton className="mb-2"></Skeleton>
                    </div>
                  </div>
                </div>
                <div className="row g-0 about-destination ">
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <Skeleton shape="circle" size="5rem"></Skeleton>
                  </div>
                  <div className="col-12 col-sm-9 col-md-9 col-lg-9 dest-text align-middle">
                    <div className="mt-3">
                      <Skeleton className="mb-2"></Skeleton>
                      <Skeleton className="mb-2"></Skeleton>
                    </div>
                  </div>
                </div>
                <div className="row g-0 about-destination ">
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <Skeleton shape="circle" size="5rem"></Skeleton>
                  </div>
                  <div className="col-12 col-sm-9 col-md-9 col-lg-9 dest-text align-middle">
                    <div className="mt-3">
                      <Skeleton className="mb-2"></Skeleton>
                      <Skeleton className="mb-2"></Skeleton>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                <div className="row g-0 about-destination ">
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <Skeleton shape="circle" size="5rem"></Skeleton>
                  </div>
                  <div className="col-12 col-sm-9 col-md-9 col-lg-9 dest-text align-middle">
                    <div className="mt-3">
                      <Skeleton className="mb-2"></Skeleton>
                      <Skeleton className="mb-2"></Skeleton>
                    </div>
                  </div>
                </div>
                <div className="row g-0 about-destination ">
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <Skeleton shape="circle" size="5rem"></Skeleton>
                  </div>
                  <div className="col-12 col-sm-9 col-md-9 col-lg-9 dest-text align-middle">
                    <div className="mt-3">
                      <Skeleton className="mb-2"></Skeleton>
                      <Skeleton className="mb-2"></Skeleton>
                    </div>
                  </div>
                </div>
                <div className="row g-0 about-destination ">
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <Skeleton shape="circle" size="5rem"></Skeleton>
                  </div>
                  <div className="col-12 col-sm-9 col-md-9 col-lg-9 dest-text align-middle">
                    <div className="mt-3">
                      <Skeleton className="mb-2"></Skeleton>
                      <Skeleton className="mb-2"></Skeleton>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4 col-md-4 col-lg-4 pt-4">
                <Skeleton width="100%" height="100%"></Skeleton>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export const NewDocumentsSkeleton = () => {
  /**
   * NewDocumentsSkeleton
   *
   * Renders a skeleton component for latest documents.
   *
   * Returns a component that renders a list of skeleton items
   * for the latest documents section.
   *
   * @returns {JSX.Element} The rendered skeleton component.
   */

  const cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return (
    <div key={"UserSkeleton"} className="row ">
      <ul className="nav flex-column sub-simple-menu-items">
        {cols.map((item, index) => {
          return (
            <li
              key={"sub-menu-nav-" + index}
              className="nav-item sub-menu-nav-item d-flex justify-content-between latest-docs pt-1"
            >
              <div className="col-12 " key={index}>
                <Skeleton
                  width="100%"
                  height="2.0rem"
                  className="mb-2"
                ></Skeleton>
                <Skeleton
                  width="70%"
                  height="1.0rem"
                  className="mb-2"
                ></Skeleton>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export const MenuSkeleton = () => {
  /**
   * MenuSkeleton component renders a skeleton for the main menu.
   *
   * @returns {JSX.Element} The rendered skeleton component.
   */

  const cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return (
    <div key={"UserSkeleton"} className="row ">
      {cols.map((item, index) => {
        return (
          <div className="col-12 " key={index}>
            <Nav.Link key={index} className={"main-menu-item "}>
              <span>
                <Skeleton size="3rem"></Skeleton>
              </span>
            </Nav.Link>
          </div>
        );
      })}
    </div>
  );
};
